import { connect } from 'react-redux';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});


export default MainLayout => connect(mapStateToProps, null)(MainLayout);
